import Vue from 'vue';
import Router from 'vue-router';
import jwt_decode from 'jwt-decode';
import { routeRole, tokenHasAnyRole } from './Services/RoleService';
import {
    denyUnauthorisedRoute,
    hasAuthToken,
    isChangePasswordRequiredFromToken,
    redirectToSsoLogin,
} from './Services/ssoNavigation';
import AddProvider from './components/Provider/AddProvider/AddProvider';
import AddRequest from './components/AddRequest/AddRequest';
import AddShortCode from './components/Short/AddShortCode/AddShortCode';
import Dashboard from './components/Dashboard/Dashboard';
import EditSender from './components/Senders/EditSender/EditSender';
import Layout from './components/Layout/Layout';
import Payment from './components/Payment/Payment';
import Provider from './components/Provider/Provider';
import SenderInfo from './components/Senders/SenderInfo/SenderInfo';
import Short from './components/Short/Short';
import UserInfo from './components/UserManagement/UserInfo/UserInfo';
import UserManagement from './components/UserManagement/UserManagement';
import UserRegistration from './components/UserManagement/UserRegistration/UserRegistration';
import LoginUserName from './components/LoginUserName/LoginUserName';
import Login from './components/Login/Login';
import LogoutPage from './components/LogoutPage/LogoutPage';
import PaymentResult from './components/Payment/PaymentResult/PaymentResult';
import AddProviderRequest from './components/AddProviderRequest/AddProviderRequest';
import ProviderRequests from './components/ProviderRequests/ProviderRequests';
import ProviderRequestInfo from './components/ProviderRequests/ProviderRequestInfo/ProviderRequestInfo';
import Report from './components/Report/Report';
import CITCKeywords from './components/CITCKeywords/CITCKeywords';
import AddCITCKeywords from './components/CITCKeywords/AddCITCKeywords/AddCITCKeywords';
import AttachmentCategory from './components/AttachmentCategory/AttachmentCategory';
import AddAttachmentCategory from './components/AttachmentCategory/AddAttachmentCategory/AddAttachmentCategory';
import ChangeSenderType from './components/Senders/ChangeSenderType/ChangeSenderType';
import NewUpdateRequest from './components/Dashboard/UpdateRequests/NewRequest/NewUpdateRequest';
import ChangeSenderTypeRequests from './components/Dashboard/ChangeSenderTypeRequests/ChangeSenderTypeRequests';
import UpdateRequests from './components/Dashboard/UpdateRequests/UpdateRequests';
import UpdateRequestDetails from './components/Dashboard/UpdateRequests/Details/UpdateRequestDetails';
import SenderConectivitySupport from './components/SenderConectivitySupport/SenderConectivitySupport';
import RenewRequest from './components/RenewRequest/RenewRequest';
import Invoices from './components/Invoice/Invoices';
import PublicPayment from './components/PublicPayment/PublicPayment';
import TrackRequest from './components/TrackRequest/TrackRequest';
import CreditLimitTransaction from './components/CreditLimitTransaction/CreditLimitTransaction';
import ProvidersFinance from './components/ProvidersFinance/ProvidersFinance';
import EditProvidersFinance from './components/ProvidersFinance/EditProvidersFinance/EditProvidersFinance';
import BalanceInvoice from './components/BalanceInvoice/BalanceInvoice';
import SupportPaymentTransaction from './components/SupportPaymentTransaction/SupportPaymentTransaction';
import SenderRequestSupport from './components/SenderRequestSupport/SenderRequestSupport';
import SenderRequestApprovalHistory from './components/SenderRequestSupport/SenderRequestApprovalHistory/SenderRequestApprovalHistory';
import SenderRequestPaymentTransactions from './components/SenderRequestSupport/SenderRequestPaymentTransactions/SenderRequestPaymentTransactions';
import SLA from './components/SLA/SLA';
import ConnectivityActivationReport from './components/ConnectivityActivationReport/ConnectivityActivationReport';
import ExtendDurationRequests from './components/Dashboard/ExtendDurationRequests/ExtendDurationRequests';
import RenewRegisterSender from './components/Dashboard/ExtendDurationRequests/RenewRegisterSender/RenewRegisterSender';
import GetInvoice from './components/GetInvoice/GetInvoice';
import ConnectingSenderName from './components/ConnectingSenderName/ConnectingSenderName';
import ConnectingRequestDashboard from './components/ConnectingRequestDashboard/ConnectingRequestDashboard';
import ContractConnectivityDetail from './components/ContractConnectivityDetails/ContractConnectivityDetail';
import RenewContractRequest from './components/RenewContractReques/RenewContractRequest';
import UpdateContractRequest from './components/ConnectingSenderName/UpdateContractRequest/UpdateContractRequest';
import ContractRequestInfo from './components/ConnectingRequestDashboard/ContractRequestInfo/ContractRequestInfo';
import SenderConectivityDetail from './components/SenderConectivityDetail/SenderConectivityDetail';
import SenderRequestStatusDashboard from './components/SenderRequestStatusDashboard/SenderRequestStatusDashboard';
import AlertsDashboard from './components/AlertsDashboard/AlertsDashboard';
import ScamList from './components/ScamManagement/ScamList';
import AddScamList from './components/ScamManagement/AddScamList/AddScamList';
import RejectionReasonList from './components/RejectionReason/RejectionReasonList';
import ShortcodeConnectingRequest from './components/ShortcodeConnectingRequest/ShortcodeConnectingRequest';
import AddNewConnectivity from './components/ShortcodeConnectingRequest/AddNewConnectivity/AddNewConnectivity';
import SenderComplaints from './components/SenderComplaints/SenderComplaints';
import ComplaintDetails from './components/SenderComplaints/ComplaintDetails/ComplaintDetails';
import EmployeeStatistics from './components/EmployeeStatistics/EmployeeStatistics';
import AddSuggestionsAndSystemEnhancement from './components/SuggestionsAndSystemEnhancement/AddSuggestionsAndSystemEnhancement/AddSuggestionsAndSystemEnhancement';
import SuggestionsAndSystemEnhancement from './components/SuggestionsAndSystemEnhancement/SuggestionsAndSystemEnhancement';
import SuggestionsDetails from './components/SuggestionsAndSystemEnhancement/SuggestionsDetails/SuggestionsDetails';
import RatingResults from './components/Rating/RatingResults/RatingResults';
import PermissionManagement from './components/UserManagement/PermissionManagement/PermissionManagement';
import ProviderSupport from './components/ProviderSupport/ProviderSupport';
import ProviderUpdate from './components/ProviderSupport/UpdateProvider/ProviderUpdate';
import MessageTemplateDashboard from './components/MessageTemplateDashboard/MessageTemplateDashboard';
import MessageTemplateReqeust from './components/MessageTemplateReqeust/MessageTemplateReqeust';
import MessageTemplateRequestInfo from './components/MessageTemplateDashboard/MessageTemplateRequestInfo/MessageTemplateRequestInfo';
import MessageTemplateRenewal from './components/MessageTemplateDashboard/MessageTemplateRenewal/MessageTemplateRenewal';
import TemplateRenewalRequests from './components/MessageTemplateDashboard/TemplateRenewalRequests/TemplateRenewalRequests';
import UpdateMessageTemplateRequest from './components/MessageTemplateReqeust/UpdateContractRequest/UpdateMessageTemplateRequest';
import RegulationsManagement from './components/RegulationsManagement/RegulationsManagement';
import AddRegulation from './components/RegulationsManagement/AddRegulation/AddRegulation';
import PreApprovedTemplates from './components/PreApprovedTemplates/PreApprovedTemplates';
import AddPreApprovedTemplate from './components/PreApprovedTemplates/AddPreApprovedTemplate/AddPreApprovedTemplate';
import PreApprovedTemplateInfo from './components/PreApprovedTemplates/PreApprovedTemplateInfo';
import MonitorDashboardPage from './components/MonitorDashboard/MonitorDashboardPage';
import ComplaintFrequencyPerSenderDetailsPage from './components/MonitorDashboard/Notifications330/ComplaintFrequencyPerSenderDetailsPage';
import ComplaintsTimelineDetailsPage from './components/MonitorDashboard/Notifications330/ComplaintsTimelineDetailsPage';
import ComplaintsStatusesDetailsPage from './components/MonitorDashboard/Notifications330/ComplaintsStatusesDetailsPage';
import AllRequestsDetails from './components/MonitorDashboard/Requests/Overview/AllRequestsDetails/AllRequestsDetails';
import RequestTimelineDetails from './components/MonitorDashboard/Requests/Overview/RequestTimelineDetails/RequestTimelineDetails';
import DelayedRequestsDetails from './components/MonitorDashboard/Requests/Overview/DelayedRequestsDetails/DelayedRequestsDetails';
import TimelineByCustomerTypeDetails from './components/MonitorDashboard/Requests/Overview/TimelineByCustomerTypeDetails/TimelineByCustomerTypeDetails';
import RequestsBySmsProviderAndSenderTypeDetails from './components/MonitorDashboard/Requests/Senders/RequestsBySmsProviderAndSenderTypeDetails/RequestsBySmsProviderAndSenderTypeDetails';
import ActiveSendersTimelineDetails from './components/MonitorDashboard/Requests/Senders/ActiveSendersTimelineDetails/ActiveSendersTimelineDetails';
import SenderExpirationTimelineDetails from './components/MonitorDashboard/Requests/Senders/SenderExpirationTimelineDetails/SenderExpirationTimelineDetails';
import SenderRenewalTimelineDetails from './components/MonitorDashboard/Requests/Senders/SenderRenewalTimelineDetails/SenderRenewalTimelineDetails';
import SendersDurationDetails from './components/MonitorDashboard/Requests/Senders/SendersDurationDetails/SendersDurationDetails';
import SendersByNodesDetails from './components/MonitorDashboard/Requests/Senders/SendersByNodesDetails/SendersByNodesDetails';
import SenderNameLengthComplianceDetails from './components/MonitorDashboard/Requests/Senders/SenderNameLengthComplianceDetails/SenderNameLengthComplianceDetails';
import TemplateFilterCheck from './components/TemplateFilterCheck/TemplateFilterCheck';
Vue.use(Router);

function beforeEnterRegulationsRoles(to: any, from: any, next: any) {
    if (tokenHasAnyRole('Support')) {
        next();
    } else {
        denyUnauthorisedRoute(next);
    }
}
function beforeEnterPreApprovedTemplateRoles(to: any, from: any, next: any) {
    if (routeRole() === 'Support') {
        next();
    } else {
        denyUnauthorisedRoute(next);
    }
}
let fromDashboard: boolean;

const PUBLIC_ROUTE_NAMES = new Set([
    'Login',
    'LoginUserName',
    'Logout',
    'AddProviderRequest',
    'PublicPayment',
    'PaymentResult',
    'TrackRequest',
    'GetInvoice',
]);

function isPublicRoute(to: { name?: string | null }): boolean {
    return to.name != null && PUBLIC_ROUTE_NAMES.has(String(to.name));
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/Login',
            name: 'Login',
            component: Login,
            beforeEnter: (to, from, next) => {
                if (isChangePasswordRequiredFromToken()) {
                    next();
                    return;
                }
                if (hasAuthToken()) {
                    next({ name: 'Dashboard' });
                    return;
                }
                void redirectToSsoLogin();
                next(false);
            },
        },
        {
            path: '/logout',
            name: 'Logout',
            component: LogoutPage,
        },
        {
            path: '/AddProviderRequest',
            name: 'AddProviderRequest',
            component: AddProviderRequest,
        },
        {
            path: '/PublicPayment',
            name: 'PublicPayment',
            component: PublicPayment,
        },
        {
            path: '/PaymentResult',
            name: 'PaymentResult',
            component: PaymentResult,
            props: (route) => ({ isSuccess: route.params.isSuccess }),
        },
        {
            path: '/LoginUserName',
            name: 'LoginUserName',
            component: LoginUserName,
        },
        {
            path: '/TrackRequest',
            name: 'TrackRequest',
            component: TrackRequest,
        },
        {
            path: '/GetInvoice',
            name: 'GetInvoice',
            component: GetInvoice,
        },
        {
            path: '/',
            name: 'Layout',
            component: Layout,
            redirect: {
                name: 'Dashboard',
            },
            beforeEnter: (to, from, next) => {
                if (hasAuthToken()) {
                    next();
                } else {
                    denyUnauthorisedRoute(next);
                }
            },
            children: [
                {
                    path: '/Dashboard',
                    name: 'Dashboard',
                    component: Dashboard,
                    beforeEnter: (to, from, next) => {
                        const role = routeRole();
                        if (!role) {
                            denyUnauthorisedRoute(next);
                            return;
                        }
                        if (role
                            === 'Finance') {
                            next({ name: 'Invoices' });
                        }
                        else if (role
                            === 'Monitor') {
                            next({ name: 'MonitorDashboard' });
                        }
                        else if (role
                            === 'Fraud Management') {
                            next({ name: 'SenderComplaints' });
                        }
                        else if (role
                            !== 'Super Admin User' && role
                            !== 'Support') {
                            next();
                        } else if (role
                            === 'Super Admin User') {
                            next({ name: 'UserManagement' });
                        } else if (role
                            === 'Support') {
                            next({ name: 'SenderConectivitySupport' });
                        }

                        else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: false }),
                },
                {
                    path: '/ProvidersFinance',
                    name: 'ProvidersFinance',
                    component: ProvidersFinance,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support'
                            || routeRole()
                            === 'Super Admin'

                        ) {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/EmployeeStatistics',
                    name: 'EmployeeStatistics',
                    component: EmployeeStatistics,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Super Admin'

                        ) {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/SenderRequestSupport/SenderRequestApprovalHistory/:id',
                    name: 'SenderRequestApprovalHistory',
                    component: SenderRequestApprovalHistory,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }

                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                },
                {
                    path: '/SenderRequestSupport/SenderRequestPaymentTransactions/:id',
                    name: 'SenderRequestPaymentTransactions',
                    component: SenderRequestPaymentTransactions,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                },
                {
                    path: 'ProvidersFinance/EditProvidersFinance/:id',
                    name: 'EditProvidersFinance',
                    component: EditProvidersFinance,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support' ||
                            routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ChangeSenderTypeRequests',
                    name: 'ChangeSenderTypeRequests',
                    component: ChangeSenderTypeRequests,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            !== 'Super Admin User') {
                            next();
                        } else if (routeRole()
                            === 'Super Admin User') {
                            next({ name: 'UserManagement' });
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Dashboard/SenderConectivityDetail/:senderId',
                    name: 'SenderConectivityDetail',
                    component: SenderConectivityDetail,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ senderId: route.params.senderId, layoutSup: true }),
                },
                {
                    path: '/ExtendDurationRequests',
                    name: 'ExtendDurationRequests',
                    component: ExtendDurationRequests,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/UpdateRequests',
                    name: 'UpdateRequests',
                    component: UpdateRequests,
                    beforeEnter: (to, from, next) => {
                        const role = routeRole();
                        if (role === 'Provider User' || role === 'Provider Admin' ||
                            role === 'Platform Admin' || role === 'Super Admin' ||
                            role === 'Managing Requests') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/UpdateRequests/New',
                    name: 'NewUpdateRequest',
                    component: NewUpdateRequest,
                    beforeEnter: async (to, from, next) => {
                        const role = routeRole();
                        if (role === 'Provider User' || role === 'Provider Admin') {
                            let enabled = false;
                            let optionsLoaded = false;
                            try {
                                const raw = sessionStorage.getItem('requestsOptions');
                                if (raw) {
                                    const opts = JSON.parse(raw);
                                    if (opts && typeof opts.isUpdateRequstDataEnabled === 'boolean') {
                                        enabled = opts.isUpdateRequstDataEnabled;
                                        optionsLoaded = true;
                                    }
                                }
                            } catch (e) {
                                optionsLoaded = false;
                            }
                            if (!optionsLoaded) {
                                try {
                                    const response = await fetch(
                                        window.$config.HostName + 'api/sender-requests/get-requests-options',
                                        {
                                            headers: {
                                                Authorization: 'Bearer ' + localStorage.token,
                                            },
                                        });
                                    const data = await response.json();
                                    if (data && data.result) {
                                        enabled = !!data.result.isUpdateRequstDataEnabled;
                                        let stored: any = {};
                                        try {
                                            const existing = sessionStorage.getItem('requestsOptions');
                                            if (existing) {
                                                stored = JSON.parse(existing) || {};
                                            }
                                        } catch (parseError) {
                                            stored = {};
                                        }
                                        sessionStorage.setItem('requestsOptions', JSON.stringify({
                                            ...stored,
                                            isUpdateRequstDataEnabled: enabled,
                                        }));
                                    } else {
                                        sessionStorage.setItem('requestsOptions', JSON.stringify({
                                            isUpdateRequstDataEnabled: false,
                                        }));
                                        enabled = false;
                                    }
                                } catch (fetchError) {
                                    sessionStorage.setItem('requestsOptions', JSON.stringify({
                                        isUpdateRequstDataEnabled: false,
                                    }));
                                    enabled = false;
                                }
                            }
                            if (!enabled) {
                                next({ name: 'Dashboard' });
                            } else {
                                next();
                            }
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/UpdateRequests/Details/:id',
                    name: 'UpdateRequestDetails',
                    component: UpdateRequestDetails,
                    beforeEnter: (to, from, next) => {
                        const role = routeRole();
                        if (role === 'Provider User' || role === 'Provider Admin' ||
                            role === 'Platform Admin' || role === 'Super Admin' ||
                            role === 'Managing Requests') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ShortcodeConnectingRequest',
                    name: 'ShortcodeConnectingRequest',
                    component: ShortcodeConnectingRequest,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ShortcodeConnectingRequest/AddNewConnectivity',
                    name: 'AddNewConnectivity',
                    component: AddNewConnectivity,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ExtendDurationRequests/RenewRegisterSender',
                    name: 'RenewRegisterSender',
                    component: RenewRegisterSender,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Dashboard/AddRequest',
                    name: 'AddRequest',
                    component: AddRequest,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Dashboard/RenewRequest/:id',
                    name: 'RenewRequest',
                    component: RenewRequest,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                },
                {
                    path: '/Dashboard/EditSender/:id',
                    name: 'EditSender',
                    component: EditSender,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin User' || routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                },
                {
                    path: '/Dashboard/SenderInfo/:id',
                    name: 'SenderInfo',
                    component: SenderInfo,
                    beforeEnter: (to, from, next) => {
                        if (from.name === 'Dashboard' || from.name === 'EditSender') {
                            fromDashboard = true;
                        } else {
                            fromDashboard = false;
                        }
                        next();
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true, isFromDashboard: fromDashboard }),
                },
                {
                    path: '/Dashboard/ChangeSenderType/:id',
                    name: 'ChangeSenderType',
                    component: ChangeSenderType,
                    beforeEnter: (to, from, next) => {
                        if (from.name === 'Dashboard') {
                            fromDashboard = true;
                        } else {
                            fromDashboard = false;
                        }
                        next();
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true, isFromDashboard: fromDashboard }),
                },
                {
                    path: '/Dashboard/Payment/',
                    name: 'Payment',
                    component: Payment,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true, isFromDashboard: fromDashboard }),
                },
                {
                    path: '/ConnectingRequestDashboard/ContractConnectivityDetail/:senderId',
                    name: 'ContractConnectivityDetail',
                    component: ContractConnectivityDetail,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ senderId: route.params.senderId, layoutSup: true }),
                },
                {
                    path: '/ConnectingRequestDashboard/UpdateContractRequest/:id',
                    name: 'UpdateContractRequest',
                    component: UpdateContractRequest,
                    beforeEnter: (to, from, next) => {
                        if (from.name === 'ConnectingRequestDashboard') {
                            fromDashboard = true;
                        } else {
                            fromDashboard = false;
                        }
                        next();
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true, isFromDashboard: fromDashboard }),
                },
                {
                    path: '/MessageTemplateDashboard/UpdateMessageTemplateRequest/:id',
                    name: 'UpdateContractRequest',
                    component: UpdateMessageTemplateRequest,
                    beforeEnter: (to, from, next) => {
                        next();
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true, isFromDashboard: true }),
                },
                {
                    path: '/ConnectingRequestDashboard/ContractRequestInfo/:id',
                    name: 'ContractRequestInfo',
                    component: ContractRequestInfo,
                    beforeEnter: (to, from, next) => {
                        if (from.name === 'ConnectingRequestDashboard' || from.name === 'EditSender') {
                            fromDashboard = true;
                        } else {
                            fromDashboard = false;
                        }
                        next();
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true, isFromDashboard: fromDashboard }),
                },
                {
                    path: '/MessageTemplateDashboard/MessageTemplateRequestInfo/:id',
                    name: 'MessageTemplateRequestInfo',
                    component: MessageTemplateRequestInfo,
                    beforeEnter: (to, from, next) => {
                        next();
                    },
                    props: (route) => ({
                        id: route.params.id, layoutSup: true, isFromDashboard: true
                    }),
                },
                {
                    path: '/SenderConectivitySupport',
                    name: 'SenderConectivitySupport',
                    component: SenderConectivitySupport,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'Support'
                            || routeRole() === 'CITC Admin'
                            || routeRole() === 'CITC User'
                            || routeRole() === 'Super Admin'
                            || routeRole() === 'Provider User'
                            || routeRole() === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/SenderRequestSupport',
                    name: 'SenderRequestSupport',
                    component: SenderRequestSupport,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: false }),
                },
                {
                    path: '/SupportPaymentTransaction',
                    name: 'SupportPaymentTransaction',
                    component: SupportPaymentTransaction,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: false }),
                },
                {
                    path: '/UserManagement',
                    name: 'UserManagement',
                    component: UserManagement,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin User' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/CreditLimitTransaction',
                    name: 'CreditLimitTransaction',
                    component: CreditLimitTransaction,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'Platform Admin' ||
                            routeRole() === 'Super Admin User' ||
                            routeRole() === 'Finance' ||
                            routeRole() === 'Provider Admin' ||
                            routeRole() === 'Provider User' ||
                            routeRole() === 'Super Admin' ||
                            routeRole() === 'Managing Requests') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Report',
                    name: 'Report',
                    component: Report,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'Platform Admin' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'CITC User' ||
                            routeRole() === 'Super Admin' ||
                            routeRole() === 'Managing Requests') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ConnectivityActivationReport',
                    name: 'ConnectivityActivationReport',
                    component: ConnectivityActivationReport,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'CITC Admin'
                            || routeRole()
                            === 'CITC User' || routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: false }),
                },
                {
                    path: '/CITCKeywords',
                    name: 'CITCKeywords',
                    component: CITCKeywords,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'CITC Admin'
                            || routeRole()
                            === 'Super Admin'
                            || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/CITCKeywords/AddCITCKeywords',
                    name: 'AddCITCKeywords',
                    component: AddCITCKeywords,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/CITCKeywords/AddCITCKeywords/Edit/:id',
                    name: 'AddCITCKeywords_Edit',
                    component: AddCITCKeywords,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, mode: 'Edit', layoutSup: true }),
                },
                {
                    path: '/PreApprovedTemplates',
                    name: 'PreApprovedTemplates',
                    component: PreApprovedTemplates,
                    beforeEnter: beforeEnterPreApprovedTemplateRoles,
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/PreApprovedTemplates/Add',
                    name: 'AddPreApprovedTemplate',
                    component: AddPreApprovedTemplate,
                    beforeEnter: beforeEnterPreApprovedTemplateRoles,
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/PreApprovedTemplates/Edit/:id',
                    name: 'EditPreApprovedTemplate',
                    component: AddPreApprovedTemplate,
                    beforeEnter: beforeEnterPreApprovedTemplateRoles,
                    props: (route) => ({ id: route.params.id, mode: 'Edit', layoutSup: true }),
                },
                {
                    path: '/PreApprovedTemplates/Details/:id',
                    name: 'PreApprovedTemplateInfo',
                    component: PreApprovedTemplateInfo,
                    beforeEnter: beforeEnterPreApprovedTemplateRoles,
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Regulations',
                    name: 'RegulationsManagement',
                    component: RegulationsManagement,
                    beforeEnter: beforeEnterRegulationsRoles,
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Regulations/Add',
                    name: 'AddRegulation',
                    component: AddRegulation,
                    beforeEnter: beforeEnterRegulationsRoles,
                    props: (route) => ({ mode: 'Add', layoutSup: true }),
                },
                {
                    path: '/Regulations/Edit/:id',
                    name: 'EditRegulation',
                    component: AddRegulation,
                    beforeEnter: beforeEnterRegulationsRoles,
                    props: (route) => ({ id: route.params.id, mode: 'Edit', layoutSup: true }),
                },
                {
                    path: '/AttachmentCategory',
                    name: 'AttachmentCategory',
                    component: AttachmentCategory,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'CITC Admin'
                            || routeRole()
                            === 'Super Admin'
                            || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/AttachmentCategory/AddAttachmentCategory',
                    name: 'AddAttachmentCategory',
                    component: AddAttachmentCategory,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/AttachmentCategory/AddAttachmentCategory/Edit/:id',
                    name: 'AddAttachmentCategory_Edit',
                    component: AddAttachmentCategory,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, mode: 'Edit', layoutSup: true }),
                },
                {
                    path: '/Providers/ProviderRequests',
                    name: 'ProviderRequests',
                    component: ProviderRequests,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin User' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Providers/AddProvider',
                    name: 'AddProvider',
                    component: AddProvider,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin') {
                            denyUnauthorisedRoute(next);
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/UserManagement/UserRegistration',
                    name: 'UserRegistration',
                    component: UserRegistration,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin User' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),

                },
                {
                    path: '/UserManagement/UserRegistration/Edit/:id',
                    name: 'UserRegistration_Edit',
                    component: UserRegistration,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin User' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, mode: 'Edit', layoutSup: true }),
                },
                {
                    path: '/UserManagement/UserInfo/:id',
                    name: 'UserInfo',
                    component: UserInfo,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin User' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true, id: route.params.id }),

                },
                {
                    path: '/Providers/ProviderRequests/ProviderRequestInfo/:id',
                    name: 'ProviderRequestInfo',
                    component: ProviderRequestInfo,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin User' || routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true, id: route.params.id }),
                },
                {
                    path: '/Providers',
                    name: 'Providers',
                    component: Provider,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                }
                , {
                    path: '/ConnectingSenderName/:isRenew',
                    name: 'ConnectingSenderName',
                    component: ConnectingSenderName,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MessageTemplateReqeust',
                    name: 'MessageTemplateReqeust',
                    component: MessageTemplateReqeust,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MessageTemplateDashboard/MessageTemplateRenewal',
                    name: 'MessageTemplateRenewal',
                    component: MessageTemplateRenewal,
                    beforeEnter: (to, from, next) => {
                        // role() = role claim value (may be an array when the SSO adds roles); normalize via RoleService.
                        if (tokenHasAnyRole('Provider User', 'Provider Admin')) {
                            next();
                        } else {
                            next({ name: 'Login' });
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MessageTemplateDashboard/TemplateRenewalRequests',
                    name: 'TemplateRenewalRequests',
                    component: TemplateRenewalRequests,
                    beforeEnter: (to, from, next) => {
                        if (tokenHasAnyRole('Provider User', 'Provider Admin')) {
                            next();
                        } else {
                            next({ name: 'Login' });
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ConnectingRequestDashboard',
                    name: 'ConnectingRequestDashboard',
                    component: ConnectingRequestDashboard,
                    beforeEnter: (to, from, next) => {
                        const role = routeRole();
                        if (role === 'Provider User'
                            || role === 'Provider Admin'
                            || role === 'Super Admin'
                            || role === 'Platform Admin'
                            || role === 'Managing Requests'
                            || role === 'CITC Admin'
                            || role === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MessageTemplateDashboard',
                    name: 'MessageTemplateDashboard',
                    component: MessageTemplateDashboard,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Managing Requests' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ConnectingRequestDashboard/RenewRequest/',
                    name: 'RenewContractRequest',
                    component: RenewContractRequest,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                },
                {
                    path: '/Providers/EditProvider/:id',
                    name: 'EditProvider',
                    component: AddProvider,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, mode: 'Edit', layoutSup: true }),
                },
                {
                    path: '/Providers/EditProvider',
                    name: 'MyProfile',
                    component: AddProvider,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider Admin' ||
                            routeRole()
                            === 'Provider User' || routeRole()
                            === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Shorts',
                    name: 'Shorts',
                    component: Short,
                    beforeEnter: (to, from, next) => {
                        const role = routeRole();
                        if (role === 'Provider User' || role === 'Provider Admin' || role === 'Super Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Scams',
                    name: 'Scams',
                    component: ScamList,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'CITC User' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'Platform Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/RejectionReason',
                    name: 'RejectionReason',
                    component: RejectionReasonList,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Super Admin' || routeRole()
                            === 'Platform Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/SenderComplaints',
                    name: 'SenderComplaints',
                    component: SenderComplaints,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Super Admin' || routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Fraud Management' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/SenderComplaints/ComplaintDetails/:id',
                    name: 'ComplaintDetails',
                    component: ComplaintDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Super Admin' || routeRole()
                            === 'Platform Admin' || routeRole()
                            === 'Fraud Management' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                },
                {
                    path: '/Invoices',
                    name: 'Invoices',
                    component: Invoices,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Finance') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/BalanceInvoice',
                    name: 'BalanceInvoice',
                    component: BalanceInvoice,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin' || routeRole()
                            === 'Finance') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Shorts/AddShortCode/:id',
                    name: 'AddShortCode',
                    component: AddShortCode,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                }, {
                    path: '/Shorts/AddShortCode',
                    name: 'AddShortCode',
                    component: AddShortCode,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Provider User' || routeRole()
                            === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/Scams/AddScamList/:id',
                    name: 'AddScamList',
                    component: AddScamList,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'CITC User' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'Platform Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ id: route.params.id, layoutSup: true }),
                }, {
                    path: '/Scams/AddScamList',
                    name: 'AddScamList',
                    component: AddScamList,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'CITC User' || routeRole()
                            === 'Super Admin' || routeRole()
                            === 'Platform Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/SLA',
                    name: 'SLA',
                    component: SLA,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            !== '') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard',
                    name: 'MonitorDashboard',
                    component: MonitorDashboardPage,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Overview/AllRequestsDetails',
                    name: 'AllRequestsDetails',
                    component: AllRequestsDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Overview/RequestTimelineDetails',
                    name: 'RequestTimelineDetails',
                    component: RequestTimelineDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Overview/DelayedRequestsDetails',
                    name: 'DelayedRequestsDetails',
                    component: DelayedRequestsDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Overview/TimelineByCustomerTypeDetails',
                    name: 'TimelineByCustomerTypeDetails',
                    component: TimelineByCustomerTypeDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Senders/RequestsBySmsProviderAndSenderTypeDetails',
                    name: 'RequestsBySmsProviderAndSenderTypeDetails',
                    component: RequestsBySmsProviderAndSenderTypeDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Senders/ActiveSendersTimelineDetails',
                    name: 'ActiveSendersTimelineDetails',
                    component: ActiveSendersTimelineDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Senders/SenderExpirationTimelineDetails',
                    name: 'SenderExpirationTimelineDetails',
                    component: SenderExpirationTimelineDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Senders/SenderRenewalTimelineDetails',
                    name: 'SenderRenewalTimelineDetails',
                    component: SenderRenewalTimelineDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Senders/SendersDurationDetails',
                    name: 'SendersDurationDetails',
                    component: SendersDurationDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Senders/SendersByNodesDetails',
                    name: 'SendersByNodesDetails',
                    component: SendersByNodesDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/Requests/Senders/SenderNameLengthComplianceDetails',
                    name: 'SenderNameLengthComplianceDetails',
                    component: SenderNameLengthComplianceDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/ComplaintFrequencyPerSenderDetails',
                    name: 'ComplaintFrequencyPerSenderDetails',
                    component: ComplaintFrequencyPerSenderDetailsPage,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/ComplaintsTimelineDetails',
                    name: 'ComplaintsTimelineDetails',
                    component: ComplaintsTimelineDetailsPage,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/MonitorDashboard/ComplaintsStatusesDetails',
                    name: 'ComplaintsStatusesDetails',
                    component: ComplaintsStatusesDetailsPage,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: 'SenderRequestStatusDashboard',
                    name: 'SenderRequestStatusDashboard',
                    component: SenderRequestStatusDashboard,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Monitor' || routeRole()
                            === 'CITC Admin' || routeRole()
                            === 'CITC User') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: 'AlertsDashboard',
                    name: 'AlertsDashboard',
                    component: AlertsDashboard,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Monitor') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ status: route.params.status, layoutSup: true }),
                },
                {
                    path: '/AddSuggestionsAndSystemEnhancement',
                    name: 'AddSuggestionsAndSystemEnhancement',
                    component: AddSuggestionsAndSystemEnhancement,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'Provider User' ||
                            routeRole() === 'Provider Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/SuggestionsAndSystemEnhancement',
                    name: 'SuggestionsAndSystemEnhancement',
                    component: SuggestionsAndSystemEnhancement,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Super Admin' ||
                            routeRole() === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/SuggestionsDetails/:id',
                    name: 'SuggestionsDetails',
                    component: SuggestionsDetails,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Super Admin' ||
                            routeRole() === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/RatingResults',
                    name: 'RatingResults',
                    component: RatingResults,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC User' ||
                            routeRole() === 'CITC Admin' ||
                            routeRole() === 'Super Admin' ||
                            routeRole() === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/UserManagement/Permissions/:id',
                    name: 'PermissionManagement',
                    component: PermissionManagement,
                    beforeEnter: (to, from, next) => {
                        if (routeRole() === 'CITC Admin') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ProviderSupport',
                    name: 'ProviderSupport',
                    component: ProviderSupport,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/ProviderSupport/ProviderUpdate/:id',
                    name: 'ProviderUpdate',
                    component: ProviderUpdate,
                    beforeEnter: (to, from, next) => {
                        if (routeRole()
                            === 'Support') {
                            next();
                        } else {
                            denyUnauthorisedRoute(next);
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
                {
                    path: '/TemplateFilterCheck',
                    name: 'TemplateFilterCheck',
                    component: TemplateFilterCheck,
                    // The flag hides this route only. It is read by the Web tier, so the API endpoints stay
                    // reachable with it off - clearing TemplateChecker:BaseUrl is the real off switch.
                    beforeEnter: (to, from, next) => {
                        // Role first, flag second: with the flag off a signed-out visitor should still be sent
                        // to SSO sign-in, not into the Dashboard shell.
                        if (!tokenHasAnyRole('Provider Admin', 'Provider User', 'Support')) {
                            denyUnauthorisedRoute(next);
                        } else if (!(window.$config && window.$config.EnableTemplateFilterCheck === true)) {
                            next({ name: 'Dashboard' });
                        } else {
                            next();
                        }
                    },
                    props: (route) => ({ layoutSup: true }),
                },
            ],
        },
    ],
});

/** Only these routes while JWT requires password change — blocks Layout / Dashboard / Report, etc. */
const changePasswordAllowedRouteNames = new Set(['Login', 'LoginUserName']);

function isAllowedRouteWhenChangePasswordRequired(to: { name?: string | null; path?: string }): boolean {
    if (to.name != null && changePasswordAllowedRouteNames.has(String(to.name))) {
        return true;
    }
    const p = (to.path || '').split('?')[0];
    return p === '/Login' || p === '/LoginUserName';
}

router.beforeEach((to, from, next) => {
    if (isPublicRoute(to)) {
        next();
        return;
    }

    if (!hasAuthToken()) {
        denyUnauthorisedRoute(next);
        return;
    }

    if (isChangePasswordRequiredFromToken() && !isAllowedRouteWhenChangePasswordRequired(to)) {
        denyUnauthorisedRoute(next);
        return;
    }

    next();
});

export default router;